import { createContext, useContext, useEffect, useState } from 'react';
import { onSnapshot, doc } from 'firebase/firestore';
import { db } from '../../Firebase/firebase_init';

const ResultSettingsContext = createContext(null);

export const ResultSettingsProvider = ({ children }) => {
    const [data, setData] = useState(null);

    useEffect(() => {
        if (data) return;
        const unsubscribe = onSnapshot(doc(db, 'settings/result'), (snapshot) => {
            if (snapshot?.exists()) {
                const webData = snapshot.data();
                setData(webData);
            }
        });
        return () => unsubscribe();
    }, []);


    return (
        <ResultSettingsContext.Provider value={{ ...data }}>
            {children}
        </ResultSettingsContext.Provider>
    );
};

export const useResultSettings = () => useContext(ResultSettingsContext);
